// import React, { useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// function Receive() {
//   const [code, setCode] = useState("");
//   const [error, setError] = useState("");

//   const handleDownload = async () => {
//     if (!code) {
//       setError("Enter a code");
//       return;
//     }
//     const token = localStorage.getItem("token");
//     try {
//       const response = await axios.get(`${API_BASE_URL}/download/${code}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         responseType: "blob",
//       });

//       // ✅ FIX: Get the content-type from response headers
//       const contentType = response.headers["content-type"] || "application/octet-stream";
//       const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      
//       const link = document.createElement("a");
//       link.href = url;
//       const contentDisposition = response.headers["content-disposition"];
//       const filename = contentDisposition
//         ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
//         : `file_${code}`;
//       link.setAttribute("download", filename || `file_${code}`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//       setError("");
//   } catch (err) {
//   // Handle blob response errors
//   if (err.response?.data instanceof Blob) {
//     const text = await err.response.data.text();
//     try {
//       const json = JSON.parse(text);
//       setError(json.error || "Download failed");
//     } catch {
//       setError(text || "Download failed");
//     }
//   } else {
//     setError(err.response?.data?.error || "Download failed");
//   }
// }
//   };

//   const styles = {
//     container: {
//       padding: "20px",
//       backgroundColor: "#f4f4f9",
//       minHeight: "100vh",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#333",
//       marginBottom: "20px",
//     },
//     inputContainer: {
//       display: "flex",
//       maxWidth: "400px",
//       border: "1px solid #ccc",
//       borderRadius: "4px",
//       overflow: "hidden",
//     },
//     input: {
//       flex: 1,
//       padding: "10px",
//       border: "none",
//       outline: "none",
//       fontSize: "16px",
//       color: "#333",
//     },
//     button: {
//       padding: "10px 20px",
//       backgroundColor: "#ff3366",
//       color: "#fff",
//       border: "none",
//       fontSize: "20px",
//       cursor: "pointer",
//       transition: "background-color 0.3s",
//     },
//     buttonHover: {
//       backgroundColor: "#e02e5c",
//     },
//     error: {
//       marginTop: "15px",
//       color: "#e53e3e",
//       fontSize: "14px",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>Receive Files</h2>
//       <div style={styles.inputContainer}>
//         <input
//           type="text"
//           placeholder="Enter code"
//           value={code}
//           onChange={(e) => {
//             setCode(e.target.value);
//             setError("");
//           }}
//           style={styles.input}
//         />
//         <button
//           onClick={handleDownload}
//           style={styles.button}
//           onMouseOver={(e) => (e.target.style.backgroundColor = styles.buttonHover.backgroundColor)}
//           onMouseOut={(e) => (e.target.style.backgroundColor = styles.button.backgroundColor)}
//         >
//           ⬇
//         </button>
//       </div>
//       {error && <p style={styles.error}>{error}</p>}
//     </div>
//   );
// }

// export default Receive;



import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";

function Receive() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const handleDownload = async () => {
    if (!code) {
      setError("Enter a code");
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${API_BASE_URL}/download/${code}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });

      // ✅ FIX: Get the content-type from response headers
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      
      const link = document.createElement("a");
      link.href = url;
      const contentDisposition = response.headers["content-disposition"];
      const filename = contentDisposition
        ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
        : `file_${code}`;
      link.setAttribute("download", filename || `file_${code}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setError("");
    } catch (err) {
      // Handle blob response errors
      if (err.response?.data instanceof Blob) {
        const text = await err.response.data.text();
        try {
          const json = JSON.parse(text);
          setError(json.error || "Download failed");
        } catch {
          setError(text || "Download failed");
        }
      } else {
        setError(err.response?.data?.error || "Download failed");
      }
    }
  };

  const styles = {
    container: {
      padding: "50px",
      backgroundColor: "#f4f4f9",
      minHeight: "100vh",
      marginLeft: "220px",
      transition: "margin-left 0.3s ease",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "20px",
    },
    inputContainer: {
      display: "flex",
      maxWidth: "400px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      overflow: "hidden",
    },
    input: {
      flex: 1,
      padding: "10px",
      border: "none",
      outline: "none",
      fontSize: "16px",
      color: "#333",
    },
    button: {
      padding: "10px 20px",
      backgroundColor: "#ff3366",
      color: "#fff",
      border: "none",
      fontSize: "20px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    buttonHover: {
      backgroundColor: "#e02e5c",
    },
    error: {
      marginTop: "15px",
      color: "#e53e3e",
      fontSize: "14px",
    },
  };

  return (
    <>
      <style>
        {`
          @media (max-width: 768px) {
            .receive-container {
              margin-left: 0 !important;
              padding: 15px !important;
            }
            
            .receive-heading {
              font-size: 20px !important;
              margin-top: 50px !important;
            }
            
            .input-container {
              max-width: 100% !important;
            }
          }

          @media (max-width: 480px) {
            .receive-container {
              padding: 12px !important;
            }
            
            .receive-heading {
              font-size: 18px !important;
            }
            
            .receive-input {
              font-size: 14px !important;
              padding: 8px !important;
            }
            
            .receive-button {
              padding: 8px 16px !important;
              font-size: 18px !important;
            }
          }
        `}
      </style>
      <div className="receive-container" style={styles.container}>
        <h2 className="receive-heading" style={styles.heading}>Receive Files</h2>
        <div className="input-container" style={styles.inputContainer}>
          <input
            type="text"
            placeholder="Enter code"
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setError("");
            }}
            className="receive-input"
            style={styles.input}
          />
          <button
            onClick={handleDownload}
            className="receive-button"
            style={styles.button}
            onMouseOver={(e) => (e.target.style.backgroundColor = styles.buttonHover.backgroundColor)}
            onMouseOut={(e) => (e.target.style.backgroundColor = styles.button.backgroundColor)}
          >
            ⬇
          </button>
        </div>
        {error && <p style={styles.error}>{error}</p>}
      </div>
    </>
  );
}

export default Receive;
